export default __webpack_public_path__ + "static/media/monCV.43bfab61.pdf";